/** PRD：MDM 导入 Excel 单文件上限 10MB */
export const MDM_IMPORT_MAX_BYTES = 10 * 1024 * 1024

export function isMdmImportFileTooLarge(file: File): boolean {
  return file.size > MDM_IMPORT_MAX_BYTES
}

/**
 * 解析 MDM 导入错误并返回 i18n key 或后端 message
 */
export function resolveMdmImportErrorMessage(
  error: unknown,
  t: (key: string) => string
): string {
  const err = error as { code?: string; message?: string }
  if (err.code === 'MDM_IMPORT_FILE_TOO_LARGE' || err.code === '121010') {
    return t('company.mdm.importFileTooLarge')
  }
  return err.message || t('company.mdm.importFailed')
}
